import { CSSProperties } from 'styled-components';

import { LinkViewModel } from '@api/index';

import HeroCampaignBannerListing from './HeroCampaignBannerListing';
import HeroCampaignBannerNonListing from './HeroCampaignBannerNonListing';

interface StylesProps {
  descFontSize?: number;
  mainTextFontSize?: number;
  secondTextBottomMargin?: number;
  descTextBottomMargin?: number;
  linTextSize?: number;
  fadeOutLayoutStyle?: CSSProperties;
  linkDescWrapperStyle?: CSSProperties;
  descriptionStyle?: CSSProperties;
  linkWrapperStyle?: CSSProperties;
  textContainerStyles?: CSSProperties;
}

export interface ILandingHeroCampaignBannerProps {
  id?: string;
  imgSrc?: string;
  mainText: string;
  secondText: string;
  description: string;
  link: string;
  linkName?: string;
  alt?: string;
  styles: StylesProps;
}
interface HeroCampaignBannerProps {
  listing?: boolean;
  images?: string;
  data: ILandingHeroCampaignBannerProps;
  pageName?: string;
  showButton?: boolean;
  ctaText?: LinkViewModel[];
}
const HeroCampaignBanner = ({
  data,
  listing,
  images,
  pageName = '',
  showButton,
  ctaText,
}: HeroCampaignBannerProps) => {
  return (
    <>
      {listing ? (
        <HeroCampaignBannerListing
          data={data}
          images={images}
          listing={listing}
          pageName={pageName}
          showButton={showButton}
          ctaText={ctaText}
        />
      ) : (
        <HeroCampaignBannerNonListing
          data={data}
          images={images}
          listing={listing}
          pageName={pageName}
          showButton={showButton}
          ctaText={ctaText}
        />
      )}
    </>
  );
};

export default HeroCampaignBanner;
